import { GUESS_COUNT } from '../constants';
import { Answers, GameState } from '../types';
import { THEME_STORAGE_KEY } from '../theme/ThemeModeProvider';

export function cleanStore(currentGameId: number, currentGameStore: string) {
  localStorage.clear();
  localStorage.setItem(`${currentGameId}`, currentGameStore);
}

export function getStoreValues(gameId: number): {
  guessCount: number;
  answers: Answers;
  gameState: GameState;
} {
  const store = localStorage.getItem(`${gameId}`);
  const currentTheme = localStorage.getItem(THEME_STORAGE_KEY);

  console.log('currentTheme', currentTheme);

  if (!store) {
    localStorage.clear();
    // maintain theme across games
    localStorage.setItem(THEME_STORAGE_KEY, currentTheme || 'dark');

    return { answers: {}, guessCount: GUESS_COUNT, gameState: 'playing' };
  }
  cleanStore(gameId, store);

  const { guessCount, answers, gameState } = JSON.parse(store);

  // maintain theme across games
  localStorage.setItem(THEME_STORAGE_KEY, currentTheme || 'dark');

  return { guessCount, answers, gameState };
}

export function setStoreValues(gameId: number, id: string, value: unknown) {
  const store = localStorage.getItem(`${gameId}`);

  if (store) {
    const parsed = JSON.parse(store);
    parsed[id] = value;

    localStorage.setItem(`${gameId}`, JSON.stringify(parsed));
  } else {
    localStorage.setItem(`${gameId}`, JSON.stringify({ [id]: value }));
  }
}
